import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';

import '@cigna/leaf-web/lib/wc/components/tabs/tabs';

import type { LeafTabs } from '@cigna/leaf-web/lib/wc';

@Component({
  selector: 'cigna-leaf-tabs',
  template: `
    <leaf-tabs
      [size]="size"
      [fullWidth]="fullWidth"
      [activeIndex]="activeIndex"
    >
      <ng-content></ng-content>
    </leaf-tabs>
  `,
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CignaLeafTabsComponent {
  @Input() size: LeafTabs['size'];
  @Input() fullWidth: LeafTabs['fullWidth'];
  @Input() activeIndex: LeafTabs['activeIndex'];
}
